import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { wedding } from "@/lib/weddingData";
import { downloadICS } from "@/lib/calendar";
import HandHeart from "./HandHeart";

const TheDate = () => {
  return (
    <section
      id="date"
      data-testid="date-section"
      className="relative border-t border-[#c9c3b3] py-24 md:py-32"
    >
      <HandHeart
        variant={3}
        size={44}
        rotate={-14}
        className="absolute right-8 top-16 z-0 hidden opacity-90 md:block"
      />
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 relative">
        {/* Corner label row */}
        <div className="flex items-start justify-between">
          <p className="corner-label text-[#8a8580]"><span style={{ color: "#891613" }}>(02)</span> — La fecha</p>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-6 md:gap-10">
          {/* Left: massive heading */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="col-span-12 md:col-span-7"
          >
            <h2 className="display-xl">
              Viernes,
              <br />
              <span style={{ color: "#891613" }}>4 de junio</span>
              <br />
              de 2027.
            </h2>
          </motion.div>

          {/* Right: description */}
          <div className="col-span-12 md:col-span-5 md:pt-8">
            <p className="body-lead max-w-md">
              <span className="font-semibold text-[#0a0a0a]">Nos casamos.</span> Y nos hace muchísima ilusión celebrarlo con vosotros.
            </p>
            <div className="mt-8 flex flex-col gap-2">
              <a href="#location" data-testid="date-cta-location" className="corner-label nav-underline w-fit">
                Ver el lugar
              </a>
              <Link
                to="/logistica"
                data-testid="date-cta-logistica"
                onClick={() => window.scrollTo(0, 0)}
                className="corner-label nav-underline w-fit"
              >
                Cómo llegar a Granada
              </Link>
              <a href="#rsvp" data-testid="date-cta-rsvp" className="corner-label nav-underline w-fit">
                Confirmar asistencia
              </a>
              <button
                type="button"
                onClick={downloadICS}
                data-testid="add-to-calendar-btn"
                className="corner-label nav-underline text-left w-fit"
              >
                + Añadir al calendario
              </button>
            </div>
          </div>
        </div>

        {/* Countdown removed per user request */}
      </div>
    </section>
  );
};

export default TheDate;
